import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { TagIconPosition } from '../../common/Types';
import { Icon } from '../../components';

@Component
export default class Tag extends Vue {

  @Prop({ required: true }) label!: string;
  @Prop() id!: string;
  @Prop() className!: string;
  @Prop() icon!: string;
  @Prop() iconPosition!: TagIconPosition;
  @Prop() hideIcon!: boolean;

  iconCloseValue: string = 'icon-navigation-close';
  iconPositionValue: string = 'right';

  @Emit()
  onLabelClick(event: any): void {
    this.$emit('labelClick', event);
  }

  @Emit()
  onSvgClick(event: any): void {
    if (event.keyCode === '13' || event.keyCode === '32') {
      this.$emit('closeClick');
    }
  }

  render(): JSX.Element {
    return (
      <div>
        {this._renderTag()}
      </div>
    );
  }

  private _getTagContent(): JSX.Element {
    let tagContent: any = '';
    const iconPosition: TagIconPosition = this.iconPosition ? this.iconPosition : this.iconPositionValue as TagIconPosition;
    const icon: string = this.icon ? this.icon : this.iconCloseValue;

    if (!this.hideIcon) {
      iconPosition === 'left' ?
        tagContent = <div>
          {this._getSvgContent(icon)}
          {this._getLabelContent(this.label, 'left-icon')}
        </div>
        :
        tagContent = <div>
          {this._getLabelContent(this.label, 'right-icon')}
          {this._getSvgContent(icon)}
        </div>;
    } else {
      tagContent = <div>
        {this._getLabelContent(this.label, 'no-icon')}
      </div>;
    }
    return tagContent;
  }

  private _getLabelContent(label: string, classValue: string): string | JSX.Element {
    const className: string = 'tl-tag-label ' + classValue;
    return (
      label && <div onClick={() => this.onLabelClick} class={className}> {label}</div>
    );
  }

  private _renderTag(): JSX.Element {
    return (
      <div tabIndex={-1}
        id={this.id}
        className={`tl-ui tl-tag-value ${this.className ? this.className : ''}`}
        onKeyDown={() => this.$emit('keyDown')}
      >
        {this._getTagContent()}
      </div>
    );
  }

  private _getSvgContent(icon: string): JSX.Element {
    return (
      <div className='tl-tag-remove' onClick={() => this.$emit('closeClick')} tabIndex={0} onKeyUp={() => this.onSvgClick}>
        <svg className='tl-svg-close-icon'>
          <Icon name={icon} />
        </svg>
      </div>
    );
  }
}
